import { render, staticRenderFns } from "./worksComment.vue?vue&type=template&id=b7213bc2&scoped=true&"
import script from "./worksComment.vue?vue&type=script&lang=js&"
export * from "./worksComment.vue?vue&type=script&lang=js&"
import style0 from "./worksComment.vue?vue&type=style&index=0&id=b7213bc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7213bc2",
  null
  
)

export default component.exports